/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function(){


    $('body').on('click tap','#product-buy[data-action="add-to-carts"]',function(e){
        e.preventDefault();
        e.stopPropagation();
        var formElement = $(this).parents('form');
        var currentproduct = formElement.find('.Select--primary select').val();
        var currentproductQty = formElement.find('.QuantitySelector input').val();

    });
    PROJ.ajaxcart.init();

    $('.quick-buys').flickity({
        "prevNextButtons": true,
        "pageDots": false,
        "wrapAround": false,
        "contain": true,
        "groupCells": true,

        "cellAlign": "center",
        // "watchCSS": true,
        "dragThreshold": 8,

        "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}

    });

    $('body').on('click tap','.pr-quick',function(){
        $(this).toggleClass('activate');
    });

    $('.ac-title:not(.active)').each(function () {
        $(this).next().css('display', 'none');
    });
    $('body').on('click', '.ac-title', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(this).hasClass('active')) {
            $(this).next().removeClass('active');
            $(this).next().slideUp();
        } else {
            $(this).next().addClass('active');
            $(this).next().slideDown();
        }
        $(this).toggleClass('active');
    });

});


var PROJ = (typeof PROJ === 'object') ? PROJ : {};


PROJ.ajaxcart = {
    VAR: {},

    init: function () {
        var _this = this;


            $('form[action="/cart/add"].ProductForm').on('submit', (function (e) {

                e.preventDefault();
                var $addToCartForm = $(this);

                var currentproduct = $addToCartForm.find('.Select--primary select').val();
                var currentproductQty = $addToCartForm.find('.QuantitySelector input').val();

            var data = "id="+currentproduct+"&quantity="+currentproductQty;

            $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                type: 'post',
                data: data,
                success: function (itemData) {
                    //$addToCartBtn.removeClass('disabled').prop('disabled', false);
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true }));
                    if( $('.pr-quick.activate').length)
                    {
                        _this.addBuyitwith();
                    }else
                    {
                        drawercart.sidebarDrawer.open();
                    }
                },
                error: function (XMLHttpRequest) {
                }
            });
            return false;

        }));
    },
    addBuyitwith: function () {
        var data = "";
        $('.pr-quick.activate').each(function () {
            data += "&updates[" + $(this).attr("data-var-id") + "]=1";
        });
        $.ajax({
            url: '/cart/update.js',
            dataType: 'json',
            type: 'post',
            data: data,
            success: function (itemData) {
                //$addToCartBtn.removeClass('disabled').prop('disabled', false);
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true }));
                drawercart.sidebarDrawer.open();
                $('.pr-quick.activate').removeClass('activate');
            },
            error: function (XMLHttpRequest) {

            }
        });
    },
    addItem: function (id) {
        var _this = this;
        $('#mini-cart').addClass('loading');
        $('body,html').addClass('mini-cart');

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + 1 + "&id=" + id,
            dataType: "json",
            success: function (t) {
                _this.updateCart();
            },
            error: function (t, r) {
                _this.updateCart();
            }
        });
    },

    updateItem: function (id, le) {
        var _this = this;
        $('#mini-cart').addClass('loading');

        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: "quantity=" + le + "&id=" + id,
            dataType: "json",
            success: function (t) {
                _this.updateCart();
            },
            error: function (t, r) {
                _this.updateCart();
            }
        });
    }

};
